import React, { Fragment, Suspense, useEffect, useState } from "react";

import HeroSection from "@/components/homepage/HeroSection";
import Inforens from "@/components/homepage/Inforens";
import University from "@/components/homepage/University";
import Plans from "@/components/homepage/Plans";
import FaQ from "@/components/homepage/FaQ";
import { getIsModalOpen, setCurrentForm, setModalOpen } from "@/reducers/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import Membership from "@/components/homepage/Membership";
import HeroSection2 from "@/components/homepage/HeroSection2";
import { getIsGuidePanel } from "@/reducers/guideSlice";
// import CountryBlogList from "../components/homepage/CountryBlogList";
import { lazy } from "react";
// lazy load CountryBlogList
const CountryBlogList = lazy(() => import("../components/homepage/CountryBlogList"));

const Home = () => {
  const isModelOpen = useSelector(getIsModalOpen);
  const dispatch = useDispatch();
  const [activeStage, setActiveStage] = useState();
  // const isLoggedIn = useSelector(getIsLoggedIn);
  const isGuidePanel = useSelector(getIsGuidePanel);
  // console.log({ isGuidePanel, isLoggedIn });

  useEffect(() => {
    if (!localStorage.getItem("token") && !localStorage.getItem("stage")) {
      dispatch(setCurrentForm("homePageOnboarding"));
      dispatch(setModalOpen(true));
    }
  }, []);

  useEffect(() => {
    setActiveStage(localStorage.getItem("stage") ?? "");
  }, [isModelOpen]);

  return (
    <Fragment>
      {activeStage === "GotAdmission" || activeStage === "AlreadyAtUniversity" ? (
        <HeroSection2 />
      ) : (
        <HeroSection />
      )}
      {/* <WhyChooseUs /> */}
      <University />
      {/* <Guides /> */}
      <section
        style={{
          "--inforens-section-margin": isGuidePanel && "0 0 0 0",
        }}
      >
        <Inforens />
      </section>

      {/* <WhyWaiting />
      <Countries />
      <Subscribe /> */}
      {!isGuidePanel && <Plans stage={activeStage} />}
      <Membership isHomePage />

      <Suspense fallback={<div>Loading...</div>}>
        <CountryBlogList />
      </Suspense>
      {/* <YoutubeVideos /> */}
      <FaQ />
    </Fragment>
  );
};

export default Home;
